import axiosInstance from './axiosConfig';

// Issue 37: subscription/billing is scoped to a restaurant's organization, not
// to the logged-in user, so every call here takes a restaurant_uuid. Actions
// that change or cancel an existing subscription, or manage Billing Admins,
// also take currentPassword - the backend requires it (re-authentication) for
// those high-risk actions and rejects the request without it.
export const SubscriptionService = {
    getPlans: async () => {
        const response = await axiosInstance.get('/stripe/plans');
        return response.data;
    },

    createCheckoutSession: async (restaurant_uuid, planId, quantity, amountDollars, isFreeTrial, page) => {
        const response = await axiosInstance.post('/stripe/create-checkout-session', {
            restaurant_uuid,
            planId,
            successUrl: `https://app.speakyourmenu.com/subscription`,
            cancelUrl: `https://app.speakyourmenu.com/${page}`,
            amountDollars,
            isFreeTrial,
        });
        return response.data;
    },

    getAllTransactions: async () => {
        try {
            const response = await axiosInstance.get('/stripe/transactions');
            return response.data;
        } catch (error) {
            console.error('Error fetching transactions:', error);
            throw error;
        }
    },

    // Replaces the old user-scoped getSubscription(). Any staff member
    // assigned to the restaurant can call this; the response's
    // callerCanManageBilling / callerCanStartFirstSubscription flags tell the
    // UI which actions to show.
    getOrganizationSubscription: async (restaurant_uuid) => {
        const response = await axiosInstance.get('/stripe/organization-subscription', {
            params: { restaurant_uuid },
        });
        return response.data;
    },

    cancelSubscription: async (restaurant_uuid, currentPassword, immediate = false) => {
        const response = await axiosInstance.post('/stripe/cancel-subscription', {
            restaurant_uuid,
            currentPassword,
            immediate,
        });
        return response.data;
    },

    changeSubscriptionPlan: async (restaurant_uuid, currentPassword, planId, amountDollars) => {
        const response = await axiosInstance.post('/stripe/change-subscription-plan', {
            restaurant_uuid,
            currentPassword,
            planId,
            amountDollars,
        });
        return response.data;
    },

    grantBillingAdmin: async (restaurant_uuid, currentPassword, targetUserUuid) => {
        const response = await axiosInstance.post('/stripe/billing-admins/grant', {
            restaurant_uuid,
            currentPassword,
            targetUserUuid,
        });
        return response.data;
    },

    revokeBillingAdmin: async (restaurant_uuid, currentPassword, targetUserUuid) => {
        const response = await axiosInstance.post('/stripe/billing-admins/revoke', {
            restaurant_uuid,
            currentPassword,
            targetUserUuid,
        });
        return response.data;
    },

    getFinancialMetrics: async (timeframe) => {
        const url = timeframe
            ? `/stripe/financial-metrics?timeframe=${timeframe}`
            : '/stripe/financial-metrics';
        const response = await axiosInstance.get(url);
        return response.data;
    },

    getSubscriptionTable: async () => {
        const response = await axiosInstance.get('/stripe/subscription-table');
        return response.data;
    }
};
